import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { defaultTableChange1 } from "../../../../../modules/custom/customTable";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import { inputConfig } from "../config/config";
import ReceivingInputs from "./receivingInputs";
import Api from "../../../../../Services/Api";
import {
  contructQueryParam,
  fetchDataAsync,
} from "../../../../../Services/Utils";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import { ACTIVITY_TYPE, HttpStatus } from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import {
  checkIsListOtherItemChange,
  constructDataDetailOtherItems,
  constructToQRReportItem,
  validateDataDetailOtherItems,
} from "../util";
import ReceivingPreviewQR from "./receivingPreviewQR";
import { v4 as uuidv4 } from "uuid";
import { ta } from "date-fns/esm/locale";

class ReceivingDetail extends Component {
  constructor(props) {
    super(props);
    this.initialData = {
      kodeotheritem: null,
      nameotheritem: null,
      jumlah: null,
      satuanotheritem: null,
      kodeLocation: null,
      qrotheritem: null,
      numbersOfPrint: null,
      saved: false,
    };
    this.inputConfig = inputConfig[props.tab];
    this.withQrTableOptions = {
      selectableRows: "multiple",
      ...defaultTableChange1(
        this.handleChangePage,
        this.handleRowsPerPage,
        this.handleOnRowSelected
      ),
    };
    this.state = {
      loading: false,
      activityRead: true,
      warningModalVisible: false,
      submitCorrectionModalVisible: false,
      editSaveModalVisible: false,
      previewQrVisible: false,
      deleteModalVisible: false,
      warningMessage: null,
      tableConfig: [],
      tableConfigQR: this.props.tableConfig.table.firstPanelConfig,
      tableConfigNotQR: this.props.tableConfig.table.secondPanelConfig,
      tableOptions: null,
      PDF: null,
      savedDataHeader: null,
      dataDetail: null,
      selectedDataQR: [],
      selectedDataNotQR: [],
      dataTableWithQr: [],
      dataTableNoQr: [],
      dataTable: [],
      dataSupplier: [],
      dataSupplierExpedition: [],
      dataItems: [],
      isCanDelete: true,
      activeTabIndex: 0,
      warningAlert: {
        visible: false,
        title: null,
        content: null,
      },
      popupApproval: {
        data: [],
        visible: false,
        isConfirmation: false,
        barcodeNeedApproval: [],
      },
      pagination: {
          page: 1,
          limit: 5,
          totalData: 0,
      },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();

    this.props.setValue("kodeCabang", this.props.selectedCabang);

    if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
      let res = await this.fetchDataDetail(
        contructQueryParam({
          spblNo: this.props.initialValues.spblNo,
        })
      );

      const data = res?.data?.data;
      if (res.ok) {
        this.props.setValue("id", data?.id);
        this.props.setValue("spblNo", data?.spblNo);
        this.props.setValue("spblDate", data?.spblDate);
        this.props.setValue("spbmNo", data?.spbmNo);
        this.props.setValue("spbmDate", data?.spbmDate);
        this.props.setValue("slNo", data?.slNo);
        this.props.setValue("slDate", data?.slDate);
        this.props.setValue("noPolKendaraan", data?.noPolKendaraan);
        this.props.setValue("note", data?.note);
        this.props.setValue("total", data?.total);

        let supplier = data?.dataMasterSupplier;
        this.props.setValue(
          "idSupplier",
          supplier
            ? mapToObjectDDL(supplier.supplierName, supplier.supplierCode)
            : null
        );

        let supplierExp = data?.dataMasterExpedisi;
        this.props.setValue(
          "idSupplierExpedisi",
          supplierExp
            ? {
                value: supplierExp.supplierCode,
                label: supplierExp.supplierCode,
                name: supplierExp.supplierName,
              }
            : null
        );

        let dataDetailQR = data?.listDataBarcodeOtherItem.map((item) => ({
          ...item,
          kodebarang: item.dataMasterOtherItem?.kodeotheritem,
          namabaranglain: item.dataMasterOtherItem?.nameotheritem,
          kategori: item.dataMasterOtherItem?.categoryDTO?.value,
          qrcode: item.otherItemBarcode,
          locator: item.dataMasterLocator?.nameLocation,
          jmlprint: item.numbersOfPrints,
          qrCodeEncrypted: item.otherItemBarcodeEncrypted,
          saved: true,
        }));

        let dataDetailExist = data?.listReceivingDetailExist.map((item) => ({
          ...item,
          kodeotheritem: item.dataMasterOtherItem?.kodeotheritem,
          namabaranglain: item.dataMasterOtherItem?.nameotheritem,
          kategori: item.dataMasterOtherItem?.categoryDTO?.value,
          qrCode: item.otherItemBarcode || null,
          locator: item.dataMasterLocator?.nameLocation,
          jumlah: item.dataMasterOtherItem?.qty,
          satuan: item.dataMasterOtherItem?.satuanDTO?.value,
          numbersOfPrint: item.numbersOfPrint || null,
          qrCodeEncrypted: item.otherItemBarcodeEncrypted || null,
          barcode: item.barcode,
          saved: true,
        }));

        let dataDetailNoQR = data?.listReceivingDetailNonBarcode.map(
          (item) => ({
            ...item,
            kodebarang: item.dataMasterOtherItem?.kodeotheritem,
            namabaranglain: item.dataMasterOtherItem?.nameotheritem,
            kategori: item.dataMasterOtherItem?.categoryDTO?.value,
            jumlah: item?.total,
            satuan: item.dataMasterOtherItem?.satuanDTO?.value,
            locator: item.dataMasterLocator?.nameLocation,
            numbersOfPrint: item.numbersOfPrint,
            saved: true,
          })
        );

        this.setState({
          dataTableWithQr: dataDetailQR,
          dataDetailQrRollBack: dataDetailQR,
          dataTableNoQr: dataDetailNoQR,
          dataDetailNoQrRollBack: dataDetailNoQR,
          //   isCanDelete: res.data.data.checkDelete,
        });
      }
    }

    await this.fetchDataSupplierExpedition();
    await this.fetchOtherItems();
    await this.fetchDataLocator();
    this.handleTriggerLoading();
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (prevState.activityRead !== this.state.activityRead) {
      this.handleTriggerLoading();
      this.setState((prevValue) => ({
        ...prevValue,
        tableConfig: prevValue.activityRead
          ? this.props.tableConfig.table.firstPanelConfig
          : this.props.tableConfig.table.secondPanelCorrectionConfig(
              this.state.dataItems,
              this.state.dataLocator,
              this.state.dataTable,
              this.handleSelectCodeOtherItems,
              this.handleValueChange,
              this.handleMultipleLocatorChange,
              this.handleSingleLocatorChange,
              this.handleSaveRow,
              this.handleEditRow,
              this.handleDeleteRow
            ),
      }));

      if (R.isEmpty(this.state.dataItems)) {
        await this.fetchOtherItems();
      }
      this.handleTriggerLoading();
    }
  };

  handleCorrection = async (action) => {
    this.handleTriggerLoading();
    if (R.equals(action, "cancel_correction")) {
      if (!R.isNil(this.state.savedDataHeader)) {
        this.props.setValue(
          "spblDate",
          this.state.savedDataHeader.spblDate.value
        );
        this.props.setValue(
          "noPolKendaraan",
          this.state.savedDataHeader.noPolKendaraan.value
        );
        this.props.setValue(
          "idSupplierExpedisi",
          this.state.savedDataHeader.idSupplierExpedisi.value
        );
      }

      this.setState((prevState) => ({
        ...prevState,
        activityRead: !prevState.activityRead,
        dataTableWithQr: prevState.dataDetailQrRollBack,
        dataTableNoQr: prevState.dataDetailNoQrRollBack,
        dataDetailSaved: [],
      }));
    } else {
      let res = await this.fetchDataDetailCorrection(
        contructQueryParam({
          spblNo: this.props.initialValues.spblNo,
        })
      );

      if (res.ok) {
        let dataDetail = res.data.data?.listReceivingDetailExist?.map(
          (item) => {
            return {
              ...item,
              kodeotheritem: mapToObjectDDL(
                item.dataMasterOtherItem?.kodeotheritem,
                item.dataMasterOtherItem?.kodeotheritem
              ),
              namabaranglain: item.dataMasterOtherItem?.nameotheritem,
              kategori: item.dataMasterOtherItem?.categoryDTO?.value,
              jumlah: item.total,
              satuan: item.dataMasterOtherItem?.satuanDTO?.value,
              kodeLocation: item.dataMasterLocator
                ? mapToObjectDDL(
                    item.dataMasterLocator?.nameLocation,
                    item.dataMasterLocator?.kodeLocation
                  )
                : null,
              saved: true,
              qrotheritem: item.dataMasterOtherItem?.qrotheritem,
            };
          }
        );
        this.setState((prevValue) => ({
          ...prevValue,
          activityRead: !prevValue.activityRead,
          dataTable: dataDetail,
          dataDetailSaved: dataDetail,
          rawListDetailKSU: dataDetail,
        }));
      }
    }
    this.handleTriggerLoading();
  };

  // handlePreviewQrVisibility = async (action) => {
  //   this.handleTriggerLoading();
  //   if (R.equals(action, "generate")) {
  //     await this.fetchGenerateQRCode();
  //   }

  //   if (R.equals(action, "close")) {
  //     await this.componentDidMount();
  //   }

  //   this.setState((prevValue) => ({
  //     ...prevValue,
  //     selectedDataQR: [],
  //     previewQrVisible: !prevValue.previewQrVisible,
  //   }));
  //   this.handleTriggerLoading();
  // };

  handlePreviewQrVisibility = async (action) => {
    this.handleTriggerLoading();
    if (R.equals(action, "generate")) {
      if (
        !this.state.selectedDataQR ||
        this.state.selectedDataQR.length === 0
      ) {
        this.handleTriggerLoading();
        return this.handleWarningAlertVisibility(
          "PERINGATAN",
          "Data belum di ceklis, harap pilih data terlebih dahulu untuk dicetak."
        );
      }
      await this.validateQRCodePrintApproval();
    }

    if (R.equals(action, "close")) {
      await this.componentDidMount();
      this.setState((prevValue) => ({
        ...prevValue,
        selectedDataQR: [],
        previewQrVisible: false,
      }));
    }
    this.handleTriggerLoading();
  };

  handleWarningAlertVisibility = (title = null, content = null) => {
    this.setState({
      warningAlert: {
        visible: !!title,
        title,
        content,
      },
    });
  };

  validateQRCodePrintApproval = async () => {
    this.handleTriggerLoading();
    const userId = localStorage.getItem("userId");
    const { selectedDataQR } = this.state;
    const { controls, selectedCabang } = this.props;

    const payload = {
      trxId: controls.spblNo.value,
      kodeCabang: selectedCabang?.value,
      idUserPemohon: userId,
      module: "RECEIVING_BARANG_LAIN",
      listBarcode: selectedDataQR?.map((item) => item.qrcode),
    };

    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkPrintQRKSUApproval,
      menuName: "Receiving Items",
      setError: this.props.setError,
      args: payload,
    });

    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      const { listBarcodeToPrint, listBarcodeNeedApproval, listIdRequest } =
        response.data.data;
      if (listBarcodeToPrint) {
        await this.fetchGenerateQRCode();
      } else {
        this.handlePopupAlertVisibility(
          listBarcodeNeedApproval || listIdRequest,
          listBarcodeNeedApproval
        );
      }
    } else {
      throw new Error(response.data.message);
    }
    this.handleTriggerLoading();
  };

  createApprovalQRPrint = async () => {
    const { controls, selectedCabang, setError } = this.props;
    const { popupApproval } = this.state;
    const userId = localStorage.getItem("userId");

    // onTriggerLoading();

    const payload = {
      trxId: controls.spblNo.value,
      kodeCabang: selectedCabang?.value,
      idUserPemohon: userId,
      module: "RECEIVING_BARANG_LAIN",
      listBarcode: popupApproval?.barcodeNeedApproval || [],
    };
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").createApprovalPrint,
      menuName: "Receiving Items - Barang Lain",
      setError: setError,
      args: payload,
    });
    // onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handlePreviewQrVisibility("close");
      this.handlePopupAlertVisibility();
    }
  };

  handlePopupAlertVisibility = (data, barcodeNeedApproval) => {
    this.setState((prev) => ({
      popupApproval: {
        data: data || [],
        visible: !prev.popupApproval.visible,
        isConfirmation: Boolean(barcodeNeedApproval),
        barcodeNeedApproval: barcodeNeedApproval || [],
      },
    }));
  };

  handleWarningModalVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      warningModalVisible: !prevState.warningModalVisible,
    }));
  };

  handleSubmitCorrectionModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      submitCorrectionModalVisible: !prevState.submitCorrectionModalVisible,
    }));
  };

  handleEditSaveModalVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      editSaveModalVisible: !prevState.editSaveModalVisible,
    }));
  };

  handleModalDeleteVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      deleteModalVisible: !prevState.deleteModalVisible,
    }));
  };

  handleClear = () => {
    this.props.resetIgnoreKeys(["spblNo", "idSupplier"]);
    this.props.setValue("spblDate", this.currentDate);
    this.setState((prevState) => ({
      ...prevState,
      dataTable: [],
    }));
  };

  handleAddRow = () => {
    try {
      const newUnit = {
        ...this.initialData,
        id: null,
        // id: uuidv4(),
      };
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: [...prevValue.dataTable, newUnit],
        dataDetailSaved: [...prevValue.dataDetailSaved, newUnit],
      }));
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  // handleEditRow = (index) => {
  //   this.setState((prevValue) => {
  //     const newState = [...prevValue.dataTable];
  //     newState[index] = {
  //       ...newState[index],
  //       saved: !newState[index].saved,
  //     };
  //     console.log(newState);

  //     return {
  //       ...prevValue,
  //       dataTable: newState,
  //       dataDetailSaved: newState,
  //     };
  //   });
  // };

  handleEditRow = (index) => {
    this.setState((prevValue) => {
      const newDataTable = prevValue.dataTable.map((row, i) =>
        i === index ? { ...row, saved: !row.saved } : row
      );

      const newDataDetailSaved = prevValue.dataDetailSaved.map((row, i) =>
        i === index ? { ...row, saved: !row.saved } : row
      );

      return {
        ...prevValue,
        dataTable: newDataTable,
        dataDetailSaved: newDataDetailSaved,
      };
    });
  };

  // handleSaveRow = (index) => {
  //   console.log(index);
  //   console.log(this.state.dataTable);

  //   this.setState((prevValue) => {
  //     const newDataTable = prevValue.dataTable.map((row, i) =>
  //       i === index ? { ...row, saved: !row.saved } : row
  //     );

  //     const newDataDetailSaved = prevValue.dataDetailSaved.map((row, i) =>
  //       i === index ? { ...row, saved: !row.saved } : row
  //     );

  //     return {
  //       ...prevValue,
  //       dataTable: newDataTable,
  //       dataDetailSaved: newDataDetailSaved,
  //     };
  //   });
  // };

  handleSaveRow = async (index) => {
    const selectedRow = this.state.dataTable[index];
    if (!selectedRow) return;

    const { total, jumlah, kodeLocation, kodeotheritem } = selectedRow;
    const isQtyChanged = Number(total) !== Number(jumlah);

    const updateRowState = () => {
      this.setState((prev) => {
        const currentItem = prev.dataItems.find(
          (item) => item.kodeotheritem === kodeotheritem?.value
        );

        const newDataTable = prev.dataTable.map((row, i) =>
          i === index
            ? {
                ...row,
                saved: !row.saved,
                barcode: currentItem?.qrotheritem ?? row.barcode,
              }
            : row
        );

        const updatedRow = newDataTable[index];
        const newDataDetailSaved = prev.dataDetailSaved.map((row, i) =>
          i === index
            ? {
                ...updatedRow,
                barcode: currentItem?.qrotheritem ?? updatedRow.barcode,
              }
            : row
        );

        return { dataTable: newDataTable, dataDetailSaved: newDataDetailSaved };
      });
    };

    if (!isQtyChanged) return updateRowState();

    try {
      const payload = {
        kodeCabang: this.props.selectedCabang?.value,
        kodeLocator: kodeLocation?.value,
        itemCode: kodeotheritem?.value,
        previousTotal: Number(total) || 0,
        newTotal: Number(jumlah),
      };

      const response = await Api.create(
        "NAGAMAS_TRANSACTION"
      ).checkQtyOtherItem(payload);

      if (response.ok) updateRowState();
      else this.handleSubmitCorrectionModalVisibility(response.data?.message);
    } catch (error) {
      console.error("checkQty error:", error);
    }
  };

  handleDeleteRow = (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      dataTable: [...prevValue.dataTable.filter((_, idx) => idx !== index)],
      dataDetailSaved: [
        ...prevValue.dataDetailSaved.filter((_, idx) => idx !== index),
      ],
    }));
  };

  handleSelectCodeOtherItems = async (index, name, value) => {
    if (!R.isEmpty(this.state.dataItems)) {
      let otherItems = this.state.dataItems.find(
        (item) => item.kodeotheritem === value?.value
      );

      this.setState((prevValue) => {
        const newState = [...prevValue.dataTable];
        newState[index] = {
          ...newState[index],
          [name]: value,
          namabaranglain: otherItems?.nameotheritem,
          kategori: otherItems?.categoryotheritem,
          satuan: otherItems?.satuanotheritem,
          // qrotheritem: otherItems.qrotheritem,
        };

        return {
          ...prevValue,
          dataTable: newState,
        };
      });
    }
  };

  handleValueChange = (index, colName, value) => {
    this.setState((prevState) => {
      const newState = [...prevState.dataTable];
      newState[index] = {
        ...newState[index],
        [colName]: value,
      };
      return {
        ...prevState,
        dataTable: newState,
      };
    });
  };

  handleStateChange = (callback) => {
    this.setState(callback);
  };

  handleSingleLocatorChange = (index, value) => {
    this.setState((prevValue) => {
      const newState = [...prevValue.dataTable];
      newState[index] = {
        ...newState[index],
        kodeLocation: value,
      };
      return {
        ...prevValue,
        dataTable: newState,
      };
    });
  };

  handleMultipleLocatorChange = (value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      dataTable: prevValue.dataTable.map((data) => ({
        ...data,
        locator: !data.saved ? value : data.locator,
      })),
    }));
  };

  handleOnRowSelected = (listIndex) => {
    const selectedData = listIndex.map(
      (index) => this.state.dataTableWithQr[index]
    );
    this.setState((prevState) => ({
      ...prevState,
      selectedDataQR: selectedData,
    }));
  };

  handleSubmitCheck = () => {
    this.setState(
      (prev) => prev,
      () => {
        const hasUnsaved = this.state.dataDetailSaved?.some(
          (item) => item.saved === false
        );
        if (hasUnsaved) {
          this.handleWarningModalVisibility();
          return;
        }
        if (!this.state.dataTable || this.state.dataTable.length === 0) {
          this.handleWarningModalVisibility();
          return;
        }

        if (
          checkIsListOtherItemChange(
            this.state.rawListDetailKSU,
            this.state.dataTable
          )
        ) {
          this.setState((prevState) => ({
            ...prevState,
            editSaveModalVisible: !prevState.editSaveModalVisible,
          }));
        } else {
          if (
            !this.props.validate() ||
            !validateDataDetailOtherItems(
              this.state.dataDetailSaved || hasUnsaved
            )
          ) {
            this.handleWarningModalVisibility();
          } else {
            this.handleSubmit();
            // this.handleSubmitCorrectionModalVisibility();
          }
        }
        // if (
        //   !this.props.validate() ||
        //   !validateDataDetailOtherItems(
        //     this.state.dataDetailSaved || hasUnsaved
        //   )
        // ) {
        //   this.handleWarningModalVisibility();
        // } else {
        //   this.handleSubmit();
        //   // this.handleSubmitCorrectionModalVisibility();
        // }
      }
    );
  };

  handleSubmit = () => {
    let details = constructDataDetailOtherItems(this.state.dataDetailSaved);

    // this.handleSubmitCorrectionModalVisibility();
    // this.handleEditSaveModalVisibility();
    this.props.onSubmit("updated", this.props.controls, details);
  };

  handleSubmitDelete = () => {
    console.log(this.props.controls);

    this.props.onDelete(this.props.controls.spblNo.value);
    this.handleModalDeleteVisibility();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchDataDetail = async (requestParam) => {
    try {
      return await Api.create(
        "NAGAMAS_TRANSACTION"
      ).getDetailReceivingOtherItem(requestParam);
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataSupplierExpedition = async () => {
    try {
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierExpedition,
        menuName: "Receiving Unit - DGI",
        setError: this.props.setError,
        args: contructQueryParam({
          kodeCabang: this.props.selectedCabang?.value,
        }),
      });
      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataSupplierExpedition: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchOtherItems = async () => {
    try {
      let response = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllOtherItemPagingByParam({
        paramFilters: {},
        limit: null,
        page: null,
      });
      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataItems: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataLocator = async () => {
    try {
      let res = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllMasterLocationPagingByParam({
        paramFilters: { kodeCabang: this.props.selectedCabang?.value },
        page: null,
        limit: null,
      });

      if (res.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataLocator: res.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchGenerateQRCode = async () => {
    try {
      let reqBody = constructToQRReportItem(this.state.selectedDataQR);
      let res = await Api.create("NAGAMAS_REPORT").generateQRReceivingUnitKSU(
        reqBody
      );
      if (res.ok) {
        if (reqBody.length > 0) {
          await this.fetchUpdateNumberOfPrintQRCode();
        }
        this.setState((prevState) => ({
          ...prevState,
          PDF: URL.createObjectURL(res.data),
          previewQrVisible: !prevState.previewQrVisible,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchUpdateNumberOfPrintQRCode = async () => {
    try {
      const reqBody = this.state.selectedDataQR
        .map((item) => item.qrcode || item.qrCode || null)
        .filter(Boolean);

      if (reqBody.length === 0) {
        return;
      }

      const response = await Api.create(
        "NAGAMAS_TRANSACTION"
      ).updateNumberOfPrintQRCodeItems(reqBody);
    } catch (error) {
      console.error("Error saat update number of print QR code:", error);
    }
  };

  fetchDataDetailCorrection = async (requestParam) => {
    try {
      return await Api.create(
        "NAGAMAS_TRANSACTION"
      ).getDetailReceivingOtherItem(requestParam);
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handleTabSelect = (index) => {
    this.setState({ activeTabIndex: index });
  };

  renderAlertApproval = () => {
    const { popupApproval } = this.state;
    const isConfirmation = popupApproval.isConfirmation;
    const title = isConfirmation ? "Konfirmasi" : "Informasi";
    const subTitle = isConfirmation
      ? "Cetak ulang QR dengan no QR:"
      : "Pengajuan tidak dapat dilakukan sebelum pengajuan dengan No. Request: ";
    const desc = isConfirmation
      ? "Apakah anda yakin?"
      : "dilakukan keputusan APPROVE/REJECT";
    return (
      <SimpleAlert
        title={title}
        visible={popupApproval.visible}
        onClickClose={() => this.handlePopupAlertVisibility()}
        content={
          <div style={{ textAlign: "left" }}>
            <p style={{ marginBottom: "10px" }}>{subTitle}</p>
            <FlexView
              style={{ gap: "10px", maxHeight: "200px", overflowY: "auto" }}
            >
              <ul
                style={{
                  listStyleType: "circle",
                  paddingLeft: "20px",
                }}
              >
                {popupApproval.data.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </FlexView>
            <p style={{ marginTop: "10px" }}>{desc}</p>
          </div>
        }
        additionalButtons={
          isConfirmation ? (
            <FlexView vAlignContent="center" style={{ gap: "10px" }}>
              <SimpleButton onClick={() => this.handlePopupAlertVisibility()}>
                TIDAK
              </SimpleButton>
              <SimpleButton onClick={this.createApprovalQRPrint}>
                YA
              </SimpleButton>
            </FlexView>
          ) : (
            <SimpleButton onClick={() => this.handlePopupAlertVisibility()}>
              OK
            </SimpleButton>
          )
        }
      />
    );
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    console.log(this.state.dataTableWithQr);
    
    const title =
      this.props.tab === "baranglain"
        ? "Detail Penerimaan Barang Lain"
        : "Detail Penerimaan Hadiah";
    return (
      <>
        <SimpleModal
          title={title}
          visible={this.props.visible}
          onClickClose={() => this.props.onClickClose()}
          content={
            <ModalContainer>
              <ReceivingInputs
                {...this.props}
                inputConfig={this.inputConfig}
                activityRead={this.state.activityRead}
                dataSupplier={this.state.dataSupplier}
                dataSupplierExpedition={this.state.dataSupplierExpedition}
              />

              {this.state.activityRead ? (
                <>
                  <FlexView
                    vAlignContent="center"
                    style={{ justifyContent: "space-between" }}
                  >
                    <h3 className="margin-bottom-10px">
                      {" "}
                      {this.props.tab == "baranglain"
                        ? "Detail Penerimaan Barang Lain :"
                        : "Detail Penerimaan Hadiah :"}
                    </h3>
                    <h4 className="margin-bottom-10px">
                      Jumlah Data:{" "}
                      {this.state.activeTabIndex === 0
                        ? this.state.dataTableWithQr?.length
                        : this.state.dataTableNoQr?.length}
                    </h4>
                  </FlexView>

                  <Tabs
                    selectedIndex={this.state.activeTabIndex}
                    onSelect={this.handleTabSelect}
                  >
                    <TabList>
                      <Tab>Dengan QR</Tab>
                      <Tab>Tanpa QR</Tab>
                    </TabList>
                    <TabPanel>
                      <SimpleDataTable
                        key={`${this.state.dataTableWithQr?.length}-${this.state.pagination.page}`}
                        data={this.state.dataTableWithQr}
                        columns={this.state.tableConfigQR}
                        options={{...this.withQrTableOptions, serverSide: false,}}
                        toCount={this.state.dataTableWithQr.length}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                      />
                    </TabPanel>
                    <TabPanel>
                      <SimpleDataTable
                        key={`${this.state.dataTableNoQr?.length}-${this.state.pagination.page}`}
                        data={this.state.dataTableNoQr}
                        columns={this.state.tableConfigNotQR}
                        options={{...this.withQrTableOptions, serverSide: false,}}
                        toCount={this.state.dataTableNoQr.length}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                      />
                    </TabPanel>
                  </Tabs>
                </>
              ) : (
                <>
                  <FlexView
                    vAlignContent="center"
                    className="margin-bottom-10px"
                  >
                    <h4 className="margin-right-10px">Barang Lain :</h4>
                    <SimpleButton
                      className={"btn btn-plus background-red margin-left-10px"}
                      onClick={this.handleAddRow}
                      style={{ width: 145 }}
                      icon={<i className="fa fa-plus margin-right-10px"></i>}
                      text={"Tambah Barang"}
                    />
                  </FlexView>
                  <SimpleDataTable
                    key={`${this.state.dataTable?.length}-${this.state.pagination.page}`}
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                    options={{...this.withQrTableOptions, serverSide: false,}}
                    toCount={this.state.dataTable.length}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                  />
                </>
              )}

              <br />
              <FlexView
                style={{
                  justifyContent:
                    this.state.activeTabIndex === 0 && this.state.activityRead
                      ? "space-between"
                      : "flex-end",
                }}
              >
                {this.state.activeTabIndex === 0 && this.state.activityRead && (
                  <SimpleButton
                    className="margin-left-none margin-top-10px"
                    text={"Print QR"}
                    onClick={() => this.handlePreviewQrVisibility("generate")}
                  />
                )}

                {this.state.activityRead ? (
                  <FlexView vAlignContent="bottom">
                    {this.props.userAccess &&
                      this.props.userAccess.updateAccess && (
                        <SimpleButton
                          type="button"
                          text="Koreksi"
                          onClick={() => this.handleCorrection("correction")}
                        />
                      )}

                    {this.props.userAccess &&
                      this.props.userAccess.deleteAccess && (
                        <SimpleButton
                          type="button"
                          text="Hapus"
                          onClick={this.handleModalDeleteVisibility}
                        />
                      )}

                    <SimpleButton
                      type="button"
                      text="Keluar"
                      onClick={() => this.props.onClickClose()}
                    />
                  </FlexView>
                ) : (
                  <FlexView vAlignContent="bottom">
                    <SimpleButton
                      type="button"
                      text="Clear"
                      onClick={this.handleClear}
                    />
                    <SimpleButton
                      type="button"
                      text="Simpan"
                      onClick={this.handleSubmitCheck}
                    />
                    <SimpleButton
                      type="button"
                      text="Batal"
                      onClick={() => this.handleCorrection("cancel_correction")}
                    />
                  </FlexView>
                )}
              </FlexView>
            </ModalContainer>
          }
        />

        {this.state.warningModalVisible && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>
                  Ada field data yang perlu diisi atau tidak sesuai kriteria
                  isian.
                </p>
                <br />
                <p>Mohon periksa kembali.</p>
              </div>
            }
            visible={this.state.warningModalVisible}
            onClickClose={this.handleWarningModalVisibility}
            additionalButtons={
              <SimpleButton
                type="button"
                text="OK"
                onClick={() => this.handleWarningModalVisibility()}
              />
            }
          />
        )}

        {this.state.submitCorrectionModalVisible && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>{this.state.warningMessage}</p>
              </div>
            }
            // content={
            //   <div>
            //     <p>Perubahan jumlah akan men-generate QR Code Item baru.</p>
            //     <p>Apakah Anda yakin mau merubah nilah jumlah di tabel ini?</p>
            //   </div>
            // }
            visible={this.state.submitCorrectionModalVisible}
            onClickClose={this.handleSubmitCorrectionModalVisibility}
            additionalButtons={
              <FlexView style={{ gap: "15px" }}>
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Batal"
                  onClick={() => this.handleSubmitCorrectionModalVisibility()}
                />
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Iya"
                  onClick={() => this.handleSubmit()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.deleteModalVisible && (
          <SimpleAlert
            title={"Warning!"}
            content={"Apakah Anda Yakin?"}
            visible={this.state.deleteModalVisible}
            onClickClose={this.handleModalDeleteVisibility}
            onSubmit={this.handleSubmitDelete}
            additionalButtons={
              <FlexView style={{ gap: "15px" }}>
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Batal"
                  onClick={() => this.handleModalDeleteVisibility()}
                />
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Iya"
                  onClick={() => this.handleSubmitDelete()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.editSaveModalVisible && (
          <SimpleAlert
            title={"Information"}
            // content={
            //   <div>
            //     <p>{this.state.warningMessage}</p>
            //   </div>
            // }
            content={
              <div>
                <p>Perubahan jumlah akan men-generate QR Code Item baru.</p>
                <p>Apakah Anda yakin mau merubah nilah jumlah di tabel ini?</p>
              </div>
            }
            visible={this.state.editSaveModalVisible}
            onClickClose={this.handleEditSaveModalVisibility}
            additionalButtons={
              <FlexView style={{ gap: "15px" }}>
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Batal"
                  onClick={() => this.handleEditSaveModalVisibility()}
                />
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Iya"
                  onClick={() => this.handleSubmit()}
                />
              </FlexView>
            }
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />

        {this.state.previewQrVisible && (
          <ReceivingPreviewQR
            PDF={this.state.PDF}
            visible={this.state.previewQrVisible}
            onPreviewQr={() => this.handlePreviewQrVisibility("close")}
            onStateChange={this.handleStateChange}
          />
        )}

        {this.state.warningAlert.visible && (
          <SimpleAlert
            title={this.state.warningAlert.title}
            visible={this.state.warningAlert.visible}
            onClickClose={() => this.handleWarningAlertVisibility()}
            content={
              <div>
                <p>{this.state.warningAlert.content}</p>
              </div>
            }
            additionalButtons={
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleButton
                  onClick={() => this.handleWarningAlertVisibility()}
                >
                  OK
                </SimpleButton>
              </FlexView>
            }
          />
        )}

        {this.renderAlertApproval()}
      </>
    );
  }
}

export default withFormGroup(ReceivingDetail);
